import { useCallback } from "react";
import { MakePostModalsProps } from "./modals-type";
import { ContentBody, ModalStyled } from "./style-component";
import { TitleStyled } from "../modals/modal-validate-username/style-component";

const ModalWrapper: React.FC<MakePostModalsProps> = ({
  open,
  handleClose,
  children,
  title = 'Modal',
  style
}) => {
  const handleCancel = useCallback(() => handleClose?.(false), [handleClose]);

  return (
    <ModalStyled
      open={open}
      title={
        typeof title === 'string' ? <TitleStyled>{title}</TitleStyled> : title
      }
      onCancel={handleCancel}
      footer={null}
      style={style}
      maskProps={{
        style: {
          backdropFilter: 'blur(10px)', // Apply blur effect
          backgroundColor: 'rgba(0, 0, 0, 0.3)', // Change opacity
        },
      }}
    >
      <ContentBody>
        {children}
      </ContentBody>
    </ModalStyled>
  )
}

export default ModalWrapper;